import { useState } from "react";
import { createPortal } from "react-dom";
import { KTSVG } from "../../../_metronic/helpers";
import { setLocalStorageWithEvent } from "./setLocalStorageWithEvent";

const policyUrl = "https://www.pense.co.uk/privacy-policy";

function hasNoConsentDecision(): boolean {
  try {
    return localStorage.getItem("cookieConsent") === null;
  } catch {
    return true;
  }
}

// Portalled to <body> so it sits above every page, including full-screen loaders.
export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState<boolean>(hasNoConsentDecision);

  const handleAccept = () => {
    setLocalStorageWithEvent("cookieConsent", "acceptedAll");
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "consent_update", consent_mode: "granted" });
    setIsVisible(false);
  };

  const handleReject = () => {
    setLocalStorageWithEvent("cookieConsent", "acceptedEssential");
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "consent_update", consent_mode: "denied" });
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return createPortal(
    <div className="cookie-consent">
      <div className="app-container d-flex justify-content-center">
        <div className="cookie-consent__content">
          <div className="cookie-consent__message">
            <div className="cookie-consent__icon">
              <KTSVG
                path="/media/icons/duotune/general/gen007.svg"
                className="svg-icon-2hx text-primary"
              />
            </div>
            <div>
              <p className="cookie-consent__text">
                We use cookies to enhance your experience on our website. By
                continuing to use this site, you consent to the use of cookies
                outlined in our{" "}
                <a
                  href={policyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fw-bolder text-primary"
                >
                  privacy policy
                </a>
                .
              </p>
            </div>
          </div>
          <div className="cookie-consent__actions">
            <button
              type="button"
              className="btn btn-primary text-nowrap"
              onClick={handleAccept}
            >
              Accept All
            </button>
            <button
              type="button"
              className="btn btn-light me-2 text-nowrap essential-cookies-only"
              onClick={handleReject}
              id="essential-cookies-only"
            >
              Essential Only
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};
